<div class="chart-card">
    <div class="chart-header">
        <h3 class="chart-title">{{ 'request_v2.analytics.status_chart_title' | translate }}</h3>
        <span class="chart-total" *ngIf="total > 0">{{ total }}</span>
    </div>
    <div class="chart-container">
        <canvas baseChart
            *ngIf="data.length > 0"
            type="bar"
            [data]="chartData"
            [options]="chartOptions">
        </canvas>
        <div *ngIf="data.length === 0" class="no-data">
            {{ 'request_v2.analytics.no_data' | translate }}
        </div>
    </div>
</div>
